import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

export default class LightboxImage extends React.PureComponent {
  static propTypes = {
    images: PropTypes.array.isRequired,
    description: PropTypes.string,
    imageTitle: PropTypes.string,
  };

  static defaultProps = {
    description: '',
    imageTitle: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false,
    };
  }

  render() {
    const { photoIndex, isOpen } = this.state;

    return (
      <div>
        <button
          type="button"
          className="btn btn-link"
          width="200"
          onClick={() => this.setState({ isOpen: true })}
        >
          <img
            className="mw-100 mh-100"
            src={this.props.images[photoIndex]}
            alt="There's always money in the banana stand."
            title={this.props.description}
          />
        </button>

        {isOpen && (
          <Lightbox
            mainSrc={this.props.images[photoIndex]}
            onCloseRequest={() => this.setState({ isOpen: false })}
            reactModalStyle={{
              overlay: { zIndex: 1150 },
            }}
            imageTitle={this.props.imageTitle}
          />
        )}
      </div>
    );
  }
}
